import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { AlgoliaBroker } from '@fnModels/algolia/broker';
import { Select } from '@ngxs/store';
import { BrokerSearchState } from '@state/algolia-search/broker-search';
import {
	BrokerageSearchDispatch,
	BrokerageSearchState,
} from '@state/algolia-search/brokerage-search';
import { Observable } from 'rxjs';
import { AI_GENERATED_ICON, ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { BrokerSearchDispatch } from '@state/algolia-search/broker-search/broker-search.dispatch';
import { Brokerage } from '@models/matter';
import { Employee } from '@models/company';
import { CreateOrUpdateBrokerageModel } from '../../create/create.component';
import { TestHooks } from './search.hooks';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';

export enum DropdownSelect {
	SELECTBROKERAGE = 'SelectBrokerage',
	SELECTBROKER = 'SelectBroker',
}

@UntilDestroy()
@Component({
	selector: 'app-aps-brokerage-search-side-form-input',
	templateUrl: './search.component.html',
	standalone: false,
})
export class BrokerageSearchSideFormInputComponent implements OnInit {
	testHooks = TestHooks;
	public brokagesLoading = false;
	public selected;
	public ICON = ICON;
	public AI_ICON = AI_GENERATED_ICON.icon;
	public AI_TOOLTIP = AI_GENERATED_ICON.tooltip;
	public AI_CLASSES = AI_GENERATED_ICON.classes;
	public showDropdown = false;
	public _brokers = [];
	public _brokerages = [];
	public loading = false;
	public brokerageModel: CreateOrUpdateBrokerageModel;
	public dropdownSelect = DropdownSelect;

	@Input() label = '';
	@Input() isClient;
	@Input() skeletonLoading = false;
	@Input() showAiIcon = false;

	brokerageName = '';
	saleId;
	@ViewChild('brokerage', { static: true }) brokerage: ElementRef;

	@Output() onSelectedBrokerage = new EventEmitter<Brokerage>();
	@Output() onSelectedBroker = new EventEmitter<AlgoliaBroker>();
	@Output() onRemoveBroker = new EventEmitter();
	@Output() onFocus = new EventEmitter();
	@Output() onCreate = new EventEmitter();

	@Select(BrokerageSearchState.getList) brokerages$: Observable<Brokerage[]>;
	@Select(BrokerageSearchState.getSearching) searchingBrokerages$: Observable<
		boolean[]
	>;

	@Select(BrokerSearchState.getList) brokers$: Observable<Employee[]>;
	@Select(BrokerSearchState.getSearching)
	searchingBrokers$: Observable<boolean>;

	@SelectSnapshot(SelectedMatter.isLeapMatter) isLeapMatter: boolean;

	constructor(
		private brokerSearchDispatch: BrokerSearchDispatch,
		private brokerageSearchDispatch: BrokerageSearchDispatch,
	) {
		this.brokerSearchDispatch.resetBrokerSearch();
		this.brokerageSearchDispatch.resetSearch();
	}

	ngOnInit(): void {
		combineLatest([this.brokerages$, this.brokers$])
			.pipe(
				untilDestroyed(this),
				map(([brokerages, brokers]) => {
					this.loading = false;
					this._brokerages = brokerages;
					this._brokers = brokers;
				}),
			)
			.subscribe();
	}

	search = ($event) => {
		this.loading = true;
		//if (!this.isLeapMatter) {
		// Within CLApp we don't search brokers while searching brokerages.
		this.brokerSearchDispatch.searchBrokers($event);
		//}
		this.brokerageSearchDispatch.Search($event);
	};

	_onFocus() {
		this.onFocus.emit();
	}

	createBrokerage() {
		this.brokerageModel = {
			name: this.selected,
			isClient: this.isClient,
			brokerage: null,
		};

		this.onCreate.emit(this.brokerageModel);
	}

	onSelect = (ev: DropdownResult<AlgoliaBroker | Brokerage>) => {
		if (ev.groupType === DropdownSelect.SELECTBROKERAGE) {
			const result = ev.result as Brokerage;
			this.onSelectedBrokerage.emit(result);
		} else if (ev.groupType === DropdownSelect.SELECTBROKER) {
			const result = ev.result as AlgoliaBroker;
			this.onSelectedBroker.emit(result);
		}
	};
}
